import { SignUp } from 'containers/Auth'

export default SignUp
